module.exports = __webpack_public_path__ + "static/media/Platformbanner@2x.433c2aac.png";